import { css, keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { TextAccent } from '../../components';
import { rem } from '../../utils/utils';

const imageWrapperStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  margin-top: 27px;
  margin-left: -15px;
  margin-right: -15px;
  ${breakpoint.fromDesktop} {
    margin-top: 47px;
    margin-left: 0;
    margin-right: 0;
  }
`;

const figcaptionStyles = ({
  theme: {
    color,
    font,
    grid: { breakpoint },
  },
}) => css`
  display: none;
  ${breakpoint.fromPhoneMedium} {
    display: block;
    font-size: ${rem(12)};
    font-family: monospace, ${font.inter};
    padding: 0 5px;
    position: absolute;
    bottom: 0;
    right: 0;
    padding-right: 5px;
    background: ${color.black};
    color: ${color.white};
  }
  ${breakpoint.fromTablet} {
    right: -15px;
  }
  ${breakpoint.fromDesktop} {
    right: 0;
  }
`;

const headerStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  margin-bottom: 25px;
  ${breakpoint.fromTablet} {
    margin-bottom: 40px;
  }
`;

const statStyles = css`
  font-size: ${rem(72)};
  line-height: 1;
`;

const emphasisStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  display: grid;
  grid-gap: 30px;
  ${breakpoint.fromPhoneMedium} {
    grid-template-columns: 1fr 1fr;
  }
`;

const shake = keyframes`
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: rotate(7deg);
  }

  20%,
  40%,
  60%,
  80% {
    transform: rotate(-7deg);
  }
`;
const contactCTAStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  ${breakpoint.fromPhoneMedium} {
    align-self: flex-end;
  }
  &:hover {
    figure {
      animation: ${shake} 1.5s;
    }
  }
`;
const waveWrapperStyles = css`
  margin: 0 0 15px;
  width: 64px;
  display: inline-block;
  transform-origin: bottom center;
`;

const collabListStyles = css`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

const collabItemStyles = ({
  theme: {
    color,
    grid: { breakpoint },
  },
}) => css`
  display: grid;
  align-items: center;
  padding-top: 20px;
  position: relative;
  &:not(:last-of-type) {
    padding-bottom: 20px;
    border-bottom: 1px solid ${color.grey900Transparent15};
  }
  &:first-of-type {
    padding-top: 0;
  }

  h3 {
    display: flex;
    margin-bottom: 10px;
  }

  ${breakpoint.fromPhoneMedium} {
    grid-gap: 30px;
    grid-template-columns: 150px 1fr;
    h3 {
      margin: 0;
    }
  }
`;

/**
 * Component style declarations
 */
export const ImageWrapper = styled('div')(imageWrapperStyles);
export const Figcaption = styled('figcaption')(figcaptionStyles);
export const Header = styled('header')(headerStyles);
export const Stat = styled(TextAccent)(statStyles);
export const Emphasis = styled('div')(emphasisStyles);
export const ContactCTA = styled('div')(contactCTAStyles);
export const WaveWrapper = styled('figure')(waveWrapperStyles);
export const CollabList = styled('ul')(collabListStyles);
export const CollabItem = styled('li')(collabItemStyles);
